import { EntityType } from "@mapmycustomers/shared/enum";
import MapViewState from "@mapmycustomers/shared/types/viewModel/MapViewState";

const createDefaultMapViewState = (): MapViewState => ({
  columns: [],
  filter: {},
  range: { endRow: 0, startRow: 0 },
  showOther: false,
  sidebarVisible: false,
  sort: [],
  visibleEntities: [EntityType.COMPANY, EntityType.PERSON, EntityType.DEAL],
});

export default createDefaultMapViewState;
